import { Helmet } from "react-helmet";
import AnimalGrid from "components/animalgrid";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";
import HeaderText from "components/headertext";
import PageGallery from "components/pagegallery";
import collectionMeta from "content/collections/gray-banded-kingsnake.json";
import { animalGridFromJson } from "hooks/useGallery";

const animalGridData = animalGridFromJson(collectionMeta);

const GrayBandedKingsnake = () => {
  return (
    <ContentBox>
      <Helmet>
        <title>{collectionMeta.commonName}</title>
        <meta
          name="description"
          content="See the Gray-banded Kingsnakes (Lampropeltis alterna)
            that are being kept here and learn more about their captive husbandry."
        />
        <link rel="canonical" href="https://www.gcreptiles.com/gray-banded-kingsnake" />
      </Helmet>
      <HeaderText
        title={collectionMeta.commonName}
        subtitle={collectionMeta.scientificName}
      />
      <AnimalGrid data={animalGridData} />
      <BodyText>
        I've always wanted to keep Gray-banded kingsnakes and have been
        especially interested in the Blairs phase snakes that have the wide
        orange bands around them. In the early 2000s my wife and I visited the
        home of Ric Blair where we saw maybe 100 or so of them in his
        collection. Ric said at the time that he had a compulsive desire to buy
        them up any time he saw them for sale. I completely understand.
      </BodyText>
      <BodyText>
        While I have always wanted to own them I'm not that interested in
        breeding them. Primarily because I've heard it is such a pain to get
        babies to eat and I don't have the patience for difficult eaters.
      </BodyText>
      <PageGallery slug="gray-banded-kingsnake" maxWidth="900" />
    </ContentBox>
  );
};

export default GrayBandedKingsnake;
